import React, { useState, useRef ,useEffect } from 'react';
import { parse, format, isValid } from 'date-fns';
import AutocompleteAirport from './AutocompleteAirport';
import DatePicker from 'react-datepicker';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom'; // Assuming you're using React Router
import { IoMdArrowDropdown } from 'react-icons/io'; // Down arrow icon
import { CiSearch } from "react-icons/ci";
import airportsData from '../data/airports.json';
import { FaExchangeAlt } from "react-icons/fa";

function FlightSearchFormDestinationPage(){


    {/*Destination Page values Start*/}
    const { 'from-to': fromTo } = useParams(); // Access the combined parameter
    let toAirport, startDateDestination, EndDateDestination  = '';

    if (fromTo) {
        // Split the parameter to get from and to
        const [from, to] = fromTo.split('-to-');
        //Get Airport Code By City
        const getAirportCodeByCity = (city) => {
            const airport = airportsData.find(airport => airport.name.includes(city));
            return airport ? airport.code : 'Airport code not found';
        };
       toAirport = getAirportCodeByCity(to.replace(/-/g, ' '));

        // Helper function to format dates as DD-MM-YYYY
        const formatDestinationDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

       // Calculate the start date (3 days from the current date)
        const currentDate = new Date();
        const startDate = new Date(currentDate);
        startDate.setDate(currentDate.getDate() + 3);
        startDateDestination = formatDestinationDate(startDate);

        // Calculate the return date (10 days after the start date)
        const returnDate = new Date(startDate);
        returnDate.setDate(startDate.getDate() + 10);
        EndDateDestination = formatDestinationDate(returnDate);

    }
    {/*Destination Page values End*/}
    
    {/*Search Parameters from URL Start*/}
    const queryParams = new URLSearchParams(window.location.search);

    // Extract query parameters from the URL
    const originParam = queryParams.get("origin") || "LHR";
    const destinationParam = queryParams.get("destination") || toAirport;
    const tripTypeParam = queryParams.get("tripType") || "Round Trip"; // Default to 'round-trip'
    const startDateParam = queryParams.get("startDate") || startDateDestination;
    const endDateParam = queryParams.get("endDate") || EndDateDestination;
    const adultsParam = queryParams.get("adults") || 1;
    const childrenParam = queryParams.get("children") || 0;
    const infantsParam = queryParams.get("infants") || 0;

    
    // Parse dates to match the datepicker format 'dd/MM/yyyy'
    const parseDate = (dateStr) => {
        const parsedDate = parse(dateStr, 'dd-MM-yyyy', new Date());
        return isValid(parsedDate) ? parsedDate : null;
    };

    {/*Origin Destination Fields*/}
    const [origin, setOrigin] = useState(originParam);
    const [destination, setDestination] = useState(destinationParam);


    {/*Dates Selection Start */}
    const [startDate, setStartDate] = useState(parseDate(startDateParam));
    const [endDate, setEndDate] = useState(parseDate(endDateParam));

    const handleDateChange = (dateOrDates) => {
        setShowUserInfo(true);
        if (tripType === "One Way") {
            setStartDate(dateOrDates); // Single date for "One Way"
        } else {
            const [start, end] = dateOrDates; // Array destructuring for "Round Trip"
            setStartDate(start);
            setEndDate(end);
            
        }
       
    };

    const formatDateToSendApi = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };
     
    {/*Dates Selection End */}
    
    {/*Round Trip/One Way Start */} 
    const [isOpentripType, setIsOpentripType] = useState(false);
    const [tripType, setTripType] = useState(tripTypeParam); // Default to "Round Trip"
    const dropdownRefTripType = useRef(null);
    const toggleDropdownTripType = () => setIsOpentripType(!isOpentripType);

    const handleSelectTripType = (type) => {
        setTripType(type);
        {/*if (type === "One Way") {
            setStartDate(null);
        }*/}
       
        setStartDate(null); // Clear start date to reset the calendar
        setEndDate(null);   // Clear end date too    
        setIsOpentripType(false);
    
    };


    const handleClickOutsidetripType = (event) => {
        if (dropdownRefTripType.current && !dropdownRefTripType.current.contains(event.target)) {
            setIsOpentripType(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutsidetripType);
        return () => {
        document.removeEventListener('mousedown', handleClickOutsidetripType);
        };
    }, []);
    {/*Round Trip/One Way End */} 

    {/*Passenger Select COde Start */} 
    const [isOpen, setIsOpen] = useState(false);
    const [passengers, setPassengers] = useState({
        adults: adultsParam,
        children:childrenParam,
        infants: infantsParam,
    });

    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handlePassengerChange = (type, operation) => {
        setPassengers((prev) => {
        const newValue =
            operation === 'increment' ? prev[type] + 1 : Math.max(prev[type] - 1, 0);
        return { ...prev, [type]: newValue };
        });
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    {/*Passenger Select COde End */}

    {/*Flight Class Code Start*/}
    const [flightClass, setFlightClass] = useState('ECONOMY'); 
    const flightClassOptions = [
        { label: 'Economy', value: 'ECONOMY' },
        { label: 'Premium Economy', value: 'PREMIUM_ECONOMY' },
        { label: 'Business', value: 'BUSINESS' },
        { label: 'First Class', value: 'FIRST' },
    ];
    const handleClassSelect = (value) => {
        setFlightClass(value); // Update state with API-compatible value
    };
    {/*Flight Class Code End*/}
   
     // Disable keyboard input on datepicker field
    const disableKeyboardInput = (event) => {
        event.preventDefault();
    };

    const getAirportName = (code) => {
        const airport = airportsData.find(airport => airport.code === code);
        return airport ? airport.name : 'Airport not found';
    };
    
     {/*Name, Email, Phone Field*/}
    const [username, setUsername]=useState('');
    const [useremail, setUseremail] = useState('');
    const [phonenumber, setPhonenumber] = useState('');
    const [showUserInfo, setShowUserInfo] = useState(false); // To show user info fields

   /*Validation and Form Submission*/
    const [errors, setErrors] = useState({});
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,15}$/;
    // Validate required fields
    const validateForm = () => {
        const newErrors = {};
        if (!origin) newErrors.origin = 'Origin is required';
        if (!destination) newErrors.destination = 'Destination is required';
        if (!startDate) newErrors.startDate = 'Travel date is required';
        if (tripType === 'Round Trip' && !endDate) {
            newErrors.dateError = 'Return Date is required';
        }else if(tripType === 'One Way' && !startDate){
           newErrors.dateError = 'Departure Date is required'; 
        }
        if (!username) newErrors.username = 'Name is required';
        if (!useremail) {
            newErrors.useremail = 'Email is required';
        } else if (!emailRegex.test(useremail)) {
            newErrors.useremail = 'Invalid email format';
        }
        if (!phonenumber) {
            newErrors.phonenumber = 'Phone number is required';
        } else if (!phoneRegex.test(phonenumber)) {
            newErrors.phonenumber = 'Invalid phone number format (must be 10-15 digits)';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const navigate = useNavigate(); 
    const handleSearch = async (e) => {
        e.preventDefault();
        setShowUserInfo(true);
        if (validateForm()) { 

            const formData = {
                tripType,
                origin,
                destination,
                "originFullName":getAirportName(origin),
                "destinationFullName":getAirportName(destination),
                startDate: formatDateToSendApi(startDate),
                endDate: formatDateToSendApi(endDate),
                adults: passengers.adults.toString(),
                children: passengers.children.toString(),
                infants: passengers.infants.toString(),
                username,
                useremail,
                phonenumber,
                flightClass
            };
            localStorage.setItem('flightFormData', JSON.stringify(formData));
            console.log(JSON.stringify(formData));
            try {
                const response = await fetch('https://7skyseo.com/holiday-expert-server-side-files/main-search.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                });

                
            } catch (error) {
                console.error('Error:', error);
            }

            const queryParams = new URLSearchParams({
                tripType,
                origin,
                destination,
                startDate: formatDateToSendApi(startDate),
                endDate: formatDateToSendApi(endDate),
                adults: passengers.adults.toString(),
                children: passengers.children.toString(),
                infants: passengers.infants.toString(),
                flightClass
            });

            console.log("Sending data to API:", queryParams); // Debugging log
            // Navigate to the /flight-search page with the query parameters
            navigate(`/flight-search?${queryParams.toString()}`); 
        }    
    };

    // Prefill the form with URL data when the component mounts
    useEffect(() => {
        setOrigin(originParam);
        setDestination(destinationParam);
        setTripType(tripTypeParam);
    }, []);

     // UseEffect to update state if dates change in the URL
    useEffect(() => {
        setStartDate(parseDate(startDateParam));
        setEndDate(parseDate(endDateParam));
    }, [startDateParam, endDateParam]);

    // UseEffect to prefill passengers' state when the component mounts
    useEffect(() => {
        setPassengers({
        adults: adultsParam,
        children: childrenParam,
        infants: infantsParam,
        });
    }, [adultsParam, childrenParam, infantsParam]);

   useEffect(() => {
        // Scroll to top whenever the component renders
        window.scrollTo(0, 0);
    }, []);

    const [key, setKey] = useState(0); // Key to force re-render
    
    // Function to swap origin, destination, and labels
    const handleSwitch = () => {
        setKey((prevKey) => prevKey + 1);
        setOrigin(destination);
        setDestination(origin);
    };

    return (
        <>
        {/* BreadCrumb Starts */}
      <section className="breadcrumb-main pt-2 pb-0" >
        <div className="container">
            
            <div className="book-form w-100 pb-1 z-index1 rounded">
                
                    <div className='row'>
                        <h2 className='topHeading'>Find Out Best Deals For Your Next Trip</h2>
                        <div className='col-lg-2 col-xs-3' >
                                <div className="trip-type-dropdown" ref={dropdownRefTripType}>
                                <button className="trip-type-button" onClick={toggleDropdownTripType}>
                                    {tripType} <IoMdArrowDropdown className="dropdown-arrow" />
                                </button>

                                {isOpentripType && (
                                    <div className="dropdown-content tripTypeDropDowns">
                                    <button className={tripType === "Round Trip" ? "active" : ""} onClick={() => handleSelectTripType('Round Trip')}>
                                        Round Trip
                                    </button>
                                    <button className={tripType === "One Way" ? " active" : ""} onClick={() => { handleSelectTripType('One Way')}}>
                                        One Way
                                    </button>
                                    </div>
                                )}
                                </div>
                        </div>
                        
                        
                    </div>

                    <div className='row formFieldsRow switch-container'>
                        <div className="col-lg mb-2 departureField">
                            <div className="form-group ">
                                <label className="mb-3"></label>
                                <div className="input-box autoComplete">
                                {/* <span className='searchFormIcons'><FaPlaneDeparture /></span> */}
                                     <AutocompleteAirport key={key} label="Flying From?" onSelectAirport={setOrigin}  autoComplete="off" defaultValue={origin} />
                                    {errors.origin && <p style={{ color: 'red' }}>{errors.origin}</p>}
                                </div>
                            </div>
                        </div>
                        <div 
                            className="switch-btn" 
                            onClick={handleSwitch}
                        >
                            <div className="switch-icon">
                            <FaExchangeAlt />
                            </div>
                        </div>
                        <div className="col-lg mb-2 destinationField destinationFieldHomepage">
                            <div className="form-group">
                                <div className="input-box autoComplete">
                                    <label className="mb-3"></label> 
                                    {/*<span className='searchFormIcons'><FaPlaneArrival /></span> */}
                                    <AutocompleteAirport key={key} label="Flying To?" onSelectAirport={setDestination} defaultValue={destination} />
                                    {errors.destination && <p style={{ color: 'red' }}>{errors.destination}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg mb-2 dateSelectionField">
                            <div className="form-group ">
                                <div className="input-box">
                                <label className="mb-3"></label>
                                {/*<span className='searchFormIcons'><FaRegCalendarAlt /></span>*/}
                                <DatePicker
                                    id="date-range"
                                    selected={startDate}
                                    onChange={handleDateChange}
                                    startDate={startDate}
                                    endDate={tripType === "Round Trip" ? endDate : null}
                                    selectsRange={tripType === "Round Trip"}
                                    monthsShown={2} // Show 2 months in one view
                                    minDate={new Date()} // Disable past dates 
                                    placeholderText={
                                        tripType === "Round Trip"
                                        ? "Select your travel dates"
                                        : "Select your departure date"
                                    }
                                    autoComplete="off"
                                    dateFormat="dd/MM/yyyy"
                                    onKeyDown={disableKeyboardInput} // Disable keyboard input
                                    popperPlacement="bottom-end"
                                    popperProps={{
                                        positionFixed: true
                                    }}
                                    withPortal
                                    onFocus={e => e.target.blur()}
                                    />
                                    {errors.dateError && <p style={{ color: 'red' }}>{errors.dateError}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg mb-2 passengerSelectionField">
                            <div className="form-group">
                                <div className="input-box">
                                    <label className="mb-3"></label>
                                    <div className="passenger-dropdown" ref={dropdownRef}>
                                        {/* Passenger Button */}
                                        <button className="passenger-button" onClick={toggleDropdown}>
                                            {passengers.adults === 1 && passengers.children === 0 && passengers.infants === 0
                                                ? `1 Adult - ${flightClassOptions.find((option) => option.value === flightClass)?.label || 'Economy'}` // Default label when no changes are made
                                                : `${passengers.adults + passengers.children + passengers.infants} Travellers - ${flightClassOptions.find((option) => option.value === flightClass)?.label || 'Economy'}`
                                            } <IoMdArrowDropdown className="dropdown-arrow" />
                                        </button>

                                        {/* Dropdown Content */}
                                        {isOpen && (
                                            <div className="dropdown-content passengerCalculate">
                                            <div className="passenger-row">
                                                {/*<FaUser className="icon" />*/}
                                                <div>
                                                <span>Adults</span>
                                                <p>Ages 13 or above</p>
                                                </div>
                                                <div className="counter">
                                                <button onClick={() => handlePassengerChange('adults', 'decrement')}>-</button>
                                                <span>{passengers.adults}</span>
                                                <button onClick={() => handlePassengerChange('adults', 'increment')}>+</button>
                                                </div>
                                            </div>
                                            <div className="passenger-row">
                                                {/*<FaChild className="icon" />*/}
                                                <div>
                                                <span>Children</span>
                                                <p>Ages 2–12</p>
                                                </div>
                                                <div className="counter">
                                                <button onClick={() => handlePassengerChange('children', 'decrement')}>-</button>
                                                <span>{passengers.children}</span>
                                                <button onClick={() => handlePassengerChange('children', 'increment')}>+</button>
                                                </div>
                                            </div>
                                            <div className="passenger-row">
                                                {/*<GiBabyBottle className="icon" />*/}
                                                <div>
                                                <span>Infants</span>
                                                <p>Ages 0–2</p>
                                                </div>
                                                <div className="counter">
                                                <button onClick={() => handlePassengerChange('infants', 'decrement')}>-</button>
                                                <span>{passengers.infants}</span>
                                                <button onClick={() => handlePassengerChange('infants', 'increment')}>+</button>
                                                </div>
                                            </div>

                                            {/* Flight Class Selection */}
                                            <div className="flight-class-section">
                                                <span>Flight Class</span>
                                                <div className="flight-class-options">
                                                    {flightClassOptions.map((option) => (
                                                        <div
                                                            key={option.value}
                                                            className={`flight-class-label ${flightClass === option.value ? 'active' : ''}`}
                                                            onClick={() => handleClassSelect(option.value)}
                                                        >
                                                            {option.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                              

                                            <button className="apply-button" onClick={() => setIsOpen(false)}>
                                                Apply
                                            </button>
                                            </div>
                                            )}
                                    </div>
                                </div>
                            </div>    
                        </div>
                        <div className="col-lg-1 mb-2 flightSearchBtn hideSearchBtn">
                            <div className="form-group mb-0 text-center">
                                <div className="input-box">
                                    <label className="mb-3"></label><br />
                                    <button className="nir-btn w-100 search-button" onClick={handleSearch}><CiSearch /></button>
                                </div>    
                            </div>
                        </div>
                    </div>

                    {showUserInfo &&(           
                    <div className='row' >
                            <div className='col-lg-4 searchFullName'>
                                <div class="form-group">
                                    <div class="input-box">
                                        <label></label>
                                        <input type="text" name="fullname" autoComplete="off" placeholder='Your Name' value={username} onChange={(e) => setUsername(e.target.value)}/>
                                        {errors.username && <p style={{ color: 'red' }}>{errors.username}</p>}
                                    </div>
                                </div>
                            </div> 
                            <div className='col-lg-4 searchEmail'>
                                <div class="form-group">
                                    <div class="input-box">
                                        <label></label>
                                        <input type="email" name="useremail" autoComplete="off" placeholder='Your Email' value={useremail} onChange={(e) => setUseremail(e.target.value)} />
                                        {errors.useremail && <p style={{ color: 'red' }}>{errors.useremail}</p>}
                                    </div>
                                </div>
                            </div> 
                            <div className='col-lg-4 searchPhoneNumber'>
                                <div class="form-group">
                                    <div class="input-box">
                                        <label></label>
                                        <input type="text" name="phonenumber" autoComplete="off" placeholder='Your Phone' value={phonenumber} onChange={(e) => setPhonenumber(e.target.value)} />
                                        {errors.phonenumber && <p style={{ color: 'red' }}>{errors.phonenumber}</p>}
                                    </div>
                                </div>
                            </div> 
                            
                        </div>            
                        )}
                        <div className='row showSearchBtn'  >
                            <div className="col-lg-1 mb-2 flightSearchBtn">
                                <div className="form-group mb-0 text-center">
                                    <div className="input-box">
                                        <label className="mb-3"></label><br />
                                        <button className="nir-btn w-100 search-button" onClick={handleSearch}><CiSearch /></button>
                                    </div>    
                                </div>
                            </div>   
                        </div>
                
            </div>
        
    </div>
</section>    
        </>
    )
}
export default FlightSearchFormDestinationPage; 